// ---------- INIT ----------

// We init AOS library (to animate elements on scroll)
this.initAOS();

// We init header events
this.initHeader();

// We init pages events
if (window.location.pathname.indexOf("faq") >= 0) {
  this.initFaqPage();
}

if (window.location.pathname.indexOf("nos-couches-francaises") >= 0) {
  this.initNosCouchesFrancaises();
}

if (window.location.pathname.indexOf("engagements-qualite") >= 0) {
  this.initEngagementsQualite();
}

if (window.location.pathname.indexOf("/products/") >= 0) {
  this.initProductPage();
}

if (window.location.pathname.indexOf("/account") >= 0) {
  this.initAccountPage();
}

// ---------- FUNCTIONS ----------
function initAOS () {

  // Global init (and disable the library on mobile)
  AOS.init({disable: 'mobile'});

}

function initHeader () {
   const curPath = window.location.href;
  
   $('.header-nav ul li a').each(function() {
    if (this.href === curPath) {
      $(this).addClass('active-item');
    }
   });
}

function initFaqPage () {
  $('.faq__heading-title').each(function() {
    const title = $(this).html().toLowerCase().replace("'", "-");
    const titleSlug = title.replace(/ /g, "-");

    $(this).attr("id", titleSlug);
  });
}

function initNosCouchesFrancaises () {
  // We add the subscription link to the image
  const curSubscriptionLinkUrl = $("#shopify-section-template--18927774564629__207d852e-dc0c-4c27-b111-b6e572b9cbf0").find(".home-module-cta a").attr("href");
  $(`<a href='${curSubscriptionLinkUrl}' class="link-feature-image"></a>`).insertBefore("#shopify-section-template--18927774564629__207d852e-dc0c-4c27-b111-b6e572b9cbf0 img.feature-image");
  $("#shopify-section-template--18927774564629__207d852e-dc0c-4c27-b111-b6e572b9cbf0 img.feature-image").appendTo("#shopify-section-template--18927774564629__207d852e-dc0c-4c27-b111-b6e572b9cbf0 .link-feature-image");

}

function initEngagementsQualite () {
  // We add the instagram link to the strip
  const curInstagramLinkUrl = $("#shopify-section-template--19221610004757__3e2e53fd-0c12-46da-9517-b09210055e14").find("a.instagram").attr("href");
  $(`<a href='${curInstagramLinkUrl}' target="_blank" class="link-instagram-image"></a>`).insertBefore("#shopify-section-template--19221610004757__3e2e53fd-0c12-46da-9517-b09210055e14 img.feature-image");
  $("#shopify-section-template--19221610004757__3e2e53fd-0c12-46da-9517-b09210055e14 img.feature-image").appendTo("#shopify-section-template--19221610004757__3e2e53fd-0c12-46da-9517-b09210055e14 .link-instagram-image");
}

function initProductPage () {
  if (window.location.pathname.indexOf("/kit-dessai-cocotte") >= 0) {
    
    this.initKitEssaiTemplate();
    
  } else {
    
    this.initDefaultProduct();
    
  }
}

function initKitEssaiTemplate () {

  // We show the choice buttons
  setTimeout(() => {
    if (window.location.href.indexOf("variant=47503314878741") >= 0) {
      
      // We add the active class on the selected size option
      $('#shopify-section-template--21322234036501__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').eq(0).addClass("active");
      
    } else if (window.location.href.indexOf("variant=47503314911509") >= 0) {
      
      // We add the active class on the selected size option
      $('#shopify-section-template--21322234036501__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').eq(1).addClass("active");
      
    } else if (window.location.href.indexOf("variant=47503314944277") >= 0) {
      
      // We add the active class on the selected size option
      $('#shopify-section-template--21322234036501__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').eq(2).addClass("active");
      
    } else if (window.location.href.indexOf("variant=47503314977045") >= 0) {
      
      // We add the active class on the selected size option
      $('#shopify-section-template--21322234036501__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').eq(3).addClass("active");
      
    } else {
      
      // We add the active class on the selected size option
      $('#shopify-section-template--21322234036501__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').eq(0).addClass("active");
    }

    $('#shopify-section-template--21322234036501__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item:not(.active) .home-module-cta').css("opacity", 1);
    
    const blueText = "La commande de ce kit déclenche un abonnement au bout de 15 jours, je peux à tout moment l'annuler depuis mon espace client."
    
    // We show the occurence text
    $(`<br /><span class="text-occurrence">${blueText}</span>`).insertBefore(".sls-selling-plan-group-first-line .sls-selling-plan-group-name .sls-savings-badge");

    // We add mention on price
    $(".product-price .conversion-bear-money").append(" *");
  }, 500);
  
  // For each size option
  $('#shopify-section-template--21322234036501__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').each(function() {

    // We get the index of the current container
    const curContainerIndex = $(this).index();
    
    // We add an id to the current size option container
    const curContainerId = `container-size-option${curContainerIndex}`;
    $(this).attr("id", curContainerId);

    // We add the size link to the image
    const curSizeLink = $(this).find(".home-module-cta a").attr("href");
    $(this).prepend(`<a href='${curSizeLink}' class="link-size-option"></a>`);
    $(this).find("img.logo-image").appendTo(`#${curContainerId} .link-size-option`);

    // We define option to open links on the same window
    $(this).find("a").attr("target", "_self");
  });

  // We listen mouseover on size option container
  $('#shopify-section-template--21322234036501__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').on("mouseenter", (e)=> {
    $(e.currentTarget).addClass("over");
    $(e.currentTarget).siblings().addClass("out");
  });

  // We listen mouseout on size option container
  $('#shopify-section-template--21322234036501__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').on("mouseleave", (e)=> {
    $(e.currentTarget).removeClass("over");
    $(e.currentTarget).siblings().removeClass("out");
  });
}

function initDefaultProduct () {
  
  // We define content vars
  let textOccurence3Weeks = "";
  let textOccurence4Weeks = "";
  let textOccurence5Weeks = "";
  let textOccurence6Weeks = "";

  // We show the choice buttons
  setTimeout(() => {
    // We get the contents for current size
    if (window.location.href.indexOf("variant=45325973651733") >= 0) {
      
      // We add the active class on the selected size option
      $('#shopify-section-template--18766359855381__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').eq(0).addClass("active");
  
      // We update content vars
      textOccurence3Weeks = "8 changes par jour";
      textOccurence4Weeks = "6 changes par jour";
      textOccurence5Weeks = "4 à 5 changes par jour";
      textOccurence6Weeks = "4 changes par jour";
      
    } else if (window.location.href.indexOf("variant=45325973684501") >= 0) {
      
      // We add the active class on the selected size option
      $('#shopify-section-template--18766359855381__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').eq(1).addClass("active");
  
      // We update content vars
      textOccurence3Weeks = "7 à 8 changes par jour";
      textOccurence4Weeks = "5 à 6 changes par jour";
      textOccurence5Weeks = "4 à 5 changes par jour";
      textOccurence6Weeks = "4 changes par jour";
      
    } else if (window.location.href.indexOf("variant=45325973717269") >= 0) {
      
      // We add the active class on the selected size option
      $('#shopify-section-template--18766359855381__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').eq(2).addClass("active");
  
      // We update content vars
      textOccurence3Weeks = "7 changes par jour";
      textOccurence4Weeks = "5 changes par jour";
      textOccurence5Weeks = "4 changes par jour";
      textOccurence6Weeks = "3 à 4 changes par jour";
      
    } else if (window.location.href.indexOf("variant=45325973750037") >= 0) {
      
      // We add the active class on the selected size option
      $('#shopify-section-template--18766359855381__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').eq(3).addClass("active");
  
      // We update content vars
      textOccurence3Weeks = "5 à 6 changes par jour";
      textOccurence4Weeks = "4 changes par jour";
      textOccurence5Weeks = "3 à 4 changes par jour";
      textOccurence6Weeks = "3 changes par jour";
      
    } else {
      
      // We add the active class on the selected size option
      $('#shopify-section-template--18766359855381__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').eq(0).addClass("active");
  
      // We update content vars
      textOccurence3Weeks = "8 changes par jour";
      textOccurence4Weeks = "6 changes par jour";
      textOccurence5Weeks = "4 à 5 changes par jour";
      textOccurence6Weeks = "4 changes par jour";
    }

    $('#shopify-section-template--18766359855381__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item:not(.active) .home-module-cta').css("opacity", 1);

    // We show the occurence texts
    $(`<br /><span class="text-occurrence">${textOccurence3Weeks}</span>`).insertBefore(".seal-table[data-selling-plan-group='0'] .sls-selling-plan-group-name .sls-savings-badge");
    $(`<span class='mention-occurrence'> (recommandé)</span><br /><span class="text-occurrence">${textOccurence4Weeks}</span>`).insertBefore(".seal-table[data-selling-plan-group='1'] .sls-selling-plan-group-name .sls-savings-badge");
    $(`<br /><span class="text-occurrence">${textOccurence5Weeks}</span>`).insertBefore(".seal-table[data-selling-plan-group='2'] .sls-selling-plan-group-name .sls-savings-badge");
    $(`<br /><span class="text-occurrence">${textOccurence6Weeks}</span>`).insertBefore(".seal-table[data-selling-plan-group='3'] .sls-selling-plan-group-name .sls-savings-badge");
  }, 1000);
  
  // For each size option
  $('#shopify-section-template--18766359855381__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').each(function() {

    // We get the index of the current container
    const curContainerIndex = $(this).index();
    
    // We add an id to the current size option container
    const curContainerId = `container-size-option${curContainerIndex}`;
    $(this).attr("id", curContainerId);

    // We add the size link to the image
    const curSizeLink = $(this).find(".home-module-cta a").attr("href");
    $(this).prepend(`<a href='${curSizeLink}' class="link-size-option"></a>`);
    $(this).find("img.logo-image").appendTo(`#${curContainerId} .link-size-option`);

    // We define option to open links on the same window
    $(this).find("a").attr("target", "_self");
  });

  // We listen mouseover on size option container
  $('#shopify-section-template--18766359855381__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').on("mouseenter", (e)=> {
    $(e.currentTarget).addClass("over");
    $(e.currentTarget).siblings().addClass("out");
  });

  // We listen mouseout on size option container
  $('#shopify-section-template--18766359855381__57e81343-df22-45f0-843a-f74d58ca5532 .dynamic-logo-list-item').on("mouseleave", (e)=> {
    $(e.currentTarget).removeClass("over");
    $(e.currentTarget).siblings().removeClass("out");
  });
  
}

function initAccountPage () {
  // For each buttons
  $('.account-info p a').each(function() {
    // We get the content
    const curContent = $(this).html();

    // We correct the translation
    if (curContent === "Subscriptions") {
      $(this).html("Gérer les abonnements");
    }
  });

  // We show the buttons
  setTimeout(() => {
    $('.account-info p a').css("opacity", 1);
  }, 500);
}